import { Component, Input, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { CatalogItem } from 'src/app/core/interfaces/catalogItem';
import { Catalog } from 'src/app/core/interfaces/catalog';
import { FreightListService } from '../cargo-list/cargo-list.service';
import { Utils } from 'src/app/core/resources/utils';

@Component({
  selector: 'app-monitoring-company-selector',
  templateUrl: './monitoring-company-selector.component.html',
  styleUrls: ['./monitoring-company-selector.component.scss']
})
export class MonitoringCompanySelectorComponent implements OnInit, OnChanges {

  @Input() monitoringCompanyControl: FormControl = new FormControl(null, [Validators.required]);
  @Input() validate: string = '';
  @Input() initialValue: { id: string, name: string } | null = null;

  monitoringCompanies: CatalogItem[] = [];
  loading: boolean = false;
  initialValueSet: boolean = false;

  constructor(
    private cargoService: FreightListService,
    public utils: Utils
  ) { }

  async ngOnInit() {
    await this.loadMonitoringCompanies();
    this.setInitialValue();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.initialValue && !this.initialValueSet)
      this.setInitialValue();
  }

  private setInitialValue() {
    if (this.initialValue && this.initialValue.id && this.initialValue.name && !this.initialValueSet) {
      if (!this.monitoringCompanies.length) this.loadMonitoringCompanies(() => this.setValueFromInitial());
      else this.setValueFromInitial();
    }
  }

  private setValueFromInitial() {
    // Buscar la empresa en el catálogo por nit (id)
    const company = this.monitoringCompanies.find(c => c.id === this.initialValue.id);
    if (company) {
      this.monitoringCompanyControl.setValue(company);
      this.initialValueSet = true;
    }
  }

  private async loadMonitoringCompanies(callback?: () => void) {
    this.loading = true;
    try {
      const success = await this.cargoService.getMonitoringCompanies().toPromise();
      if (success && success.catalog && success.catalog.length) this.monitoringCompanies = success.catalog;
      else this.monitoringCompanies = [];
    } catch (error) {
      console.error('Error al cargar empresas de monitoreo:', error);
      this.monitoringCompanies = [];
    } finally {
      this.loading = false;
      if (callback) callback();
    }
  }

  /**
   * Resetea el estado del componente para permitir nuevos valores iniciales
   */
  public resetInitialValueState() {
    this.initialValueSet = false;
  }
}

